
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes06Off as ObiDiodes06OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-06-off.js';
 
 
 

 
 export const ObiDiodes06Off = createComponent({
   react: React,
   tagName: 'obi-diodes-06-off',
   elementClass: ObiDiodes06OffElement,
   events: {
     
   }
  });
 
 